class AccountSettings.WorkCalendarWeekday extends Backbone.Model
  defaults:
    id: null,
    from: '00:00',
    to: '23:59',
    name: 'example',
    working_day: true,
    timezone: 'GMT+0000'

class AccountSettings.WorkCalendarWeekdayCollection extends Backbone.Collection
  model: AccountSettings.WorkCalendarWeekday
  url: '/keepcon/settings/work_calendar_weekdays'

  save: =>
    $.ajax
      url: @url
      method: 'POST'
      data: JSON.stringify @
      contentType: 'application/json'
      success: (response) =>
        if response.success then @trigger('saveSuccess') else @trigger('saveError', response.errors)
      error: =>
        @trigger 'saveError'
